import * as React from 'react';
import * as styles from './ExpertProfilePreview.module.scss';
import Link from 'gatsby-link';
import { GatsbyImageWrapper } from '../ui/GatsbyImageWrapper';
import { PageOverviewQuery } from '../../gatsby-queries';
import { FormattedMessage } from 'react-intl';

export class ExpertProfilePreview extends React.Component<{
	className?: string;
	url?: string;
	title: string;
	filterData: PageOverviewQuery;
	filter_expert_subjects?: string[] | string;
	filter_entity?: string[] | string;
	description: string;
	category: string;
	imageBasePath: string;
	name: string;
}> {
	public render() {
		const imageHeight = '&h=490&fit=fill';
		const expertSubjects = Array.isArray(this.props.filter_expert_subjects) ? this.props.filter_expert_subjects : [this.props.filter_expert_subjects];
		const subjectsString = (expertSubjects as string[]).map(value => this.props.filterData.allContentfulFilterExpertProfileSubject.edges.find((edge => {
			if (edge.node.contentful_id === value) {
				return true;
			}
		}))).map(edge => edge.node.title).join(' | ');
		const entities = Array.isArray(this.props.filter_entity) ? this.props.filter_entity : [this.props.filter_entity];
		const entitiesString = (entities as string[]).map(value => this.props.filterData.allContentfulEntity.edges.find((edge => {
			if (edge.node.contentful_id === value) {
				return true;
			}
		}))).map(edge => edge.node.title).join(' | ');
		const content = (
			<div className={styles.wrapperItem}>
				{this.props.imageBasePath && (
					<GatsbyImageWrapper
						fluid={{
							sizes: '100vw',
							srcSet: `${this.props.imageBasePath}?w=400${imageHeight} 400w`,
							srcSetWebp: `${this.props.imageBasePath}?w=400${imageHeight}&fm=webp 400w`,
							src: `${this.props.imageBasePath}?w=400${imageHeight}`,
							srcWebp: `${this.props.imageBasePath}?w=400${imageHeight}&fm=webp`,
							aspectRatio: 400 / 490
						}}
						alt={this.props.title}
					/>
				)}
				<div className={styles.textWrapper}>
					<div className={styles.textWrapperInner}>
					<h3 className={`${styles.name}`}>{this.props.name}</h3>
					<h5 className={`${styles.title}`}>{this.props.title}</h5>
					{this.props.description && <p className={styles.description}>{this.props.description}</p>}
					</div>
					<div className={styles.itemInfoReadMore}>
						<div className={styles.itemInfo}>
							{subjectsString}{entitiesString && (subjectsString ? ' | ' : '') + entitiesString}
						</div>
						<div className={`text-style-body ${styles.ctaLink}`}>
							<span><FormattedMessage id={'read_more'} /></span>
						</div>
					</div>
				</div>
			</div>
		);

		return (
			<div data-clickable="true" className={styles.wrapper + (this.props.className ? ' ' + this.props.className : '')}>
				{this.props.url && <Link to={this.props.url}>{content}</Link>}
				{!this.props.url && content}
			</div>
		);
	}
}
